<template>
    <v-dialog v-model="dialog" width="800px">
        <v-form ref="closeActionForm">
            <v-card>
                <v-card-title class="py-0 justify-center">Set Action {{ action.pten_code }}.{{ action.ptac_nr }} complete</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5">
                    {{ action.ptac_oms }}
                </v-row>
                <v-divider v-if="action.ptac_oms !== ''"></v-divider>
                <v-row no-gutters class="ma-4 mb-0">                
                    <v-col cols="12">
                        <v-textarea v-model="action.ptac_result" rows="3" label="Action result" dense></v-textarea>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-title class="py-0 justify-center">Follow up action</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-4">
                    <v-col cols="12">
                        <v-checkbox v-model="followUp.addFollowUp" :disabled="followUp.followUpRequired" label="Add follow up"></v-checkbox>
                    </v-col>
                </v-row>
                
                <v-row no-gutters class="mx-4">
                    <v-col cols="6" class="pr-4">
                        <v-select v-model="followUp.patp_code" :clearable="true" :items="codeKeuzes" item-value="patp_code" item-text="patp_oms" label="Type of action" v-on:change="setFollowUp" dense></v-select>
                    </v-col>  
                    <v-col cols="6">
                        <date_picker label="Complete follow up action before" :date="followUp.ptac_actie_dt" field="ptac_actie_dt" @updateData="updateData" dense v-if="this.followUpType!=='close'"/>
                        <v-select v-model="followUp.pten_stat" :clearable="true" :items="codeKeuzesClosed" item-value="ptst_code" item-text="ptst_oms" label="Reason of close" dense v-if="this.followUpType==='close'"></v-select>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mx-4">
                    <v-col cols="12">
                        <v-textarea v-model="followUp.ptac_oms" rows="3" :label="this.followUpType!=='close'?'Follow up description':'Closed description (for all open actions)'" v-bind:rules="descriptionRules" dense></v-textarea>
                    </v-col>
                </v-row>            
                <v-row no-gutters class="mx-4">
                    <v-col cols="12" class="mt-2">
                        <v-textarea v-model="followUp.pten_close" rows="3" label="Optional: Note to add to lead" dense v-if="this.followUpType==='close'"></v-textarea>
                    </v-col>
                </v-row>                 
                <v-divider v-if="this.followUpType!=='close'"></v-divider>
                <v-card-title class="py-0 justify-center" v-if="this.followUpType!=='close'">New lead status</v-card-title>
                <v-divider v-if="this.followUpType!=='close'"></v-divider >
                <v-row no-gutters class="pt-4 px-4" v-if="this.followUpType!=='close'">
                    <v-col cols=4></v-col>
                    <v-col cols=4>
                        <v-select v-model="followUp.pten_stat" :items="codeKeuzesChange" item-value="ptst_code" item-text="ptst_oms" label="Set new status" dense></v-select>
                    </v-col>
                    <v-col cols=4></v-col>
                </v-row>                 
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="closeLead" v-if="this.followUpType==='close'">Close lead</v-btn>
                    <v-btn color="primary" small @click="setComplete" v-if="this.followUpType!=='close'">Complete Action</v-btn>
                    <v-btn color="primary" small @click="closeDialog">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-form> 
    </v-dialog>
</template>

<script>
    import date_picker from "@/components/ui/date_picker.vue";
    
    export default {
        components: {
            date_picker,
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                // Type of follow up
                followUpType: "action",
                action: {},
                followUp: {},
                followUp00: {},
                followUp05: {},
                codeKeuzes: [],
                codeKeuzesChange: [],
                codeKeuzesClosed: [],
                descriptionRules: [v => !!v || "A description / value is required"],
                message: "",
            }
        },
        methods: { 
            openDialog(action) {
                this.action = action;
                this.$axios.post("ares/json/ares/pten/getAction.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAction",
                    },
                    getAction: {
                        pten_encrid: this.action.pten_encrid,
                        ptac_nr: this.action.ptac_nr,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.followUp = res.data.getAction.follow_up;
                        this.followUp.ptac_actie_dt = this.getDate(this.followUp.ptac_actie_dt);
                        this.followUp05 = res.data.getAction.follow_up_05;
                        this.followUp05.ptac_actie_dt = this.getDate(this.followUp05.ptac_actie_dt);
                        this.followUp00 = res.data.getAction.follow_up_00;
                        this.followUp00.ptac_actie_dt = this.getDate(this.followUp00.ptac_actie_dt);
                        this.codeKeuzes = res.data.getAction.patp_codeKeuzes;
                        this.codeKeuzesChange = res.data.getAction.ptst_codeKeuzes_change;
                        this.codeKeuzesClosed = res.data.getAction.ptst_codeKeuzes_closed;
                        this.dialog = true;
                    }
                });
            },
            closeLead() {
                if (!this.checkInputClosed()) {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: this.message,
                        color: "error",
                    }); 
                    return                   
                }
                this.$axios.post("ares/json/ares/pten/setPtenStatus.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenStatus",
                    },
                    setPtenStatus: {
                        pten_encrid: this.action.pten_encrid,
                        ptst_code: this.followUp.pten_stat,
                        actionResult: this.followUp.ptac_oms,
                        ptenNote: this.followUp.pten_close,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenStatus.text,
                            color: res.data.setPtenStatus.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            checkInputClosed() {
                this.message = "";
                if (this.followUp.pten_stat === "") {
                    this.message = "Missing reason of close";
                    return false;
                }
                if (this.followUp.ptac_oms === "") {
                    this.message = "Missing a description for the close of all action";
                    return false;
                }
                return true;
            },
            setComplete() {
                if (!this.checkInput()) {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: this.message,
                        color: "error",
                    }); 
                    return                   
                }
                this.$axios.post("ares/json/ares/pten/setActionComplete.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setActionComplete",
                    },
                    setActionComplete: {
                        ptac_encrid: this.action.ptac_encrid,
                        ptac_result: this.action.ptac_result,
                        follow_up: this.followUp,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setActionComplete.text,
                            color: res.data.setActionComplete.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            checkInput() {
                this.message = "";
                if (this.followUp.pten_stat === "") {
                    this.message = "Missing new lead status";
                    return false;
                }
                if (this.followUp.followUpRequired) {
                    if (this.followUp.patp_code === "") {
                        this.message = "Missing a type for follow up action";
                        return false;
                    }
                    if (this.followUp.ptac_actie_dt === "") {
                        this.message = "Missing a compleation date for the follow up action";
                        return false;
                    }
                    if (this.followUp.ptac_oms === "") {
                        this.message = "Missing a description for the follow up action";
                        return false;
                    }
                }
                this.followUp.ptac_actie_dt_ok = this.setDate(this.followUp.ptac_actie_dt);
                return true;
            },
            getDate(value) {
                if  (value === ""||value === null) {
                    return "";
                }
                if (value.substring(4, 5) === "-"||value.substring(4, 5) === "/") {
                    return value.substring(5, 7) + "-" + value.substring(8, 10) + "-" + value.substring(0, 4); 
                }
                return value.substring(3, 5) + "-" + value.substring(0, 2) + "-" + value.substring(6, 10);
            },
            setDate(date) {
                if (date.substring(2, 3) === "-") {
                    return date.substring(3, 5) + "-" + date.substring(0, 2) + "-" + date.substring(6, 10); 
                }
                return date.substring(8, 10) + "-" + date.substring(5, 7) + "-" + date.substring(0, 4); 
            },
            updateData(data) {
                this.followUp[data.field] = data.value;
            },
            closeDialog() {
                this.dialog = false;
            },
            setFollowUp () {
                switch (this.followUp.patp_code) {
                    case "05-SendFolder":
                        this.followUpType = "folder";
                        this.followUp.ptac_actie_dt = this.followUp05.ptac_actie_dt;
                        this.followUp.ptac_oms = this.followUp05.ptac_oms;
                        break;
                    case "99-Close":
                        this.followUpType = "close";
                        break;
                    default:
                        this.followUpType = "action";
                        this.followUp.ptac_actie_dt = this.followUp00.ptac_actie_dt;
                        this.followUp.ptac_oms = this.followUp00.ptac_oms;
                }
            },
        }
    }
</script>

